module.exports = __webpack_public_path__ + "img/video4.0a80cf4f.jpg";